var _line, _line2, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEclipse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 261,
    viewBox: "0 0 294 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29.5583,
    y1: 215.027,
    x2: 294,
    y2: 215.027,
    stroke: "white",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30.5583,
    y1: -2.59101e-8,
    x2: 30.5584,
    y2: 216.027,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2406 63.1179H88.675C99.9354 94.1047 126.204 156.712 141.194 159.247C156.184 161.783 172.248 96.2174 178.406 63.1179H281.596",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6445 63.3821H101.079C112.339 94.3689 138.608 156.976 153.598 159.512C168.588 162.047 184.652 96.4816 190.81 63.3821H294",
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.112 107.386H12.864V110.41H5.28V114.25H12.72V117.274H5.28V124.186H2.112V107.386Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.996 249.081H165.524V244.185H168.548V249.081H172.844V251.961H168.548V257.385C168.548 257.865 168.764 258.105 169.196 258.105H172.412V260.985H167.372C166.828 260.985 166.38 260.809 166.028 260.457C165.692 260.105 165.524 259.657 165.524 259.113V251.961H161.996V249.081Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipse);
export default __webpack_public_path__ + "static/media/Eclipse.bed2ad73f7f95f75f180713ddd79fc36.svg";
export { ForwardRef as ReactComponent };